import React, { useEffect, useState } from 'react';
import { Card, PageHeader, Badge } from '../../components/shared/ui';
import { adminAPI } from '../../utils/api';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const AppStats = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getAppStats().then(r => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader title="Başvuru İstatistikleri" description="Şirket ve ilan bazlı özet" />
      {loading ? <p className="text-ink-500">Yükleniyor...</p>
       : !data  ? <p className="text-red-600">Veri alınamadı</p>
       : (
        <div className="space-y-5 max-w-5xl">
          <Card>
            <h2 className="text-base font-semibold text-ink-900 mb-3">Şirket Bazlı Başvurular</h2>
            <div className="overflow-x-auto -mx-4 sm:mx-0">
              <table className="w-full min-w-[480px]">
                <thead className="bg-ink-50 border-b border-ink-200">
                  <tr>{['Şirket','İlan','Toplam','Kabul'].map(h => <th key={h} className="px-4 py-2 text-left text-xs font-semibold text-ink-600">{h}</th>)}</tr>
                </thead>
                <tbody>
                  {data.by_company.map((c,i) => (
                    <tr key={i} className="border-b border-ink-100">
                      <td className="px-4 py-2.5 text-sm font-medium text-ink-900">{c.company_name}</td>
                      <td className="px-4 py-2.5 text-sm text-ink-600 text-center">{c.positions}</td>
                      <td className="px-4 py-2.5 text-sm text-ink-700 text-center">{c.total_applications}</td>
                      <td className="px-4 py-2.5 text-center"><Badge tone="green">{c.accepted}</Badge></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>

          <Card>
            <h2 className="text-base font-semibold text-ink-900 mb-3">İlan Bazlı Detay</h2>
            {data.by_position.length > 0 && (
              <ResponsiveContainer width="100%" height={280}>
                <BarChart data={data.by_position.slice(0,10)} layout="vertical">
                  <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                  <XAxis type="number" tick={{ fontSize: 11 }} allowDecimals={false} />
                  <YAxis dataKey="title" type="category" tick={{ fontSize: 10 }} width={140} />
                  <Tooltip />
                  <Bar dataKey="total" name="Toplam" fill="#e5e7eb" radius={[0,4,4,0]} />
                  <Bar dataKey="invited" name="Davet" fill="#2563eb" radius={[0,4,4,0]} />
                  <Bar dataKey="accepted" name="Kabul" fill="#16a34a" radius={[0,4,4,0]} />
                </BarChart>
              </ResponsiveContainer>
            )}
            <div className="mt-4 overflow-x-auto -mx-4 sm:mx-0">
              <table className="w-full min-w-[600px]">
                <thead className="bg-ink-50 border-b border-ink-200">
                  <tr>{['İlan','Şirket','Toplam','Davet','Kabul','Red','Ort. Skor'].map(h => <th key={h} className="px-3 py-2 text-left text-xs font-semibold text-ink-600 whitespace-nowrap">{h}</th>)}</tr>
                </thead>
                <tbody>
                  {data.by_position.map((p,i) => (
                    <tr key={i} className="border-b border-ink-100">
                      <td className="px-3 py-2 text-sm font-medium text-ink-900">{p.title}</td>
                      <td className="px-3 py-2 text-xs text-ink-500">{p.company_name}</td>
                      <td className="px-3 py-2 text-sm text-center">{p.total}</td>
                      <td className="px-3 py-2 text-sm text-center text-brand-700 font-semibold">{p.invited}</td>
                      <td className="px-3 py-2 text-sm text-center text-emerald-600 font-semibold">{p.accepted}</td>
                      <td className="px-3 py-2 text-sm text-center text-red-600">{p.rejected}</td>
                      <td className="px-3 py-2 text-sm text-center text-ink-700">{p.avg_score ? `%${p.avg_score}` : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
       )}
    </>
  );
};

export default AppStats;
